import { Injectable, computed, signal } from "@angular/core";

/** Normalizes a string for substring matching: lowercase, non-alphanumerics stripped. */
export function normalizeForFilter(value: string): string {
  return value.toLowerCase().replace(/[^a-z0-9]/g, "");
}

/**
 * Holds the dev panel's live filter query. Provided per-instance by the dev
 * panel component (not `providedIn: "root"`) so the query resets whenever the
 * panel is opened/closed rather than leaking across sessions.
 */
@Injectable()
export class DevPanelFilter {
  /** Raw text the developer typed. */
  readonly query = signal("");
  /** Normalized query; empty string means "match everything". */
  readonly normalizedQuery = computed(() => normalizeForFilter(this.query()));

  setQuery(value: string): void {
    this.query.set(value);
  }

  clear(): void {
    this.query.set("");
  }
}
